import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import DropeZoneContactInfo from './DropeZoneContactInfo';

const UploaderSection = ({ filesListTenure, setFilesListTenure, filesListOthers, setFilesListOthers, children }) => {
  const translate = useIntl();
  const [error, setError] = useState('');
  const isMoreThanFive = (filesListTenure.length + filesListOthers.length) < 5;

  return (
    <div>
      <div className="contact-info__item">
        <div>
          <p className="contact-info__note">
            <FormattedMessage
              id="carbon.form.note"
              values={{ b: (chunks) => <b>{chunks}</b> }}
            />
          </p>
        </div>
        <div>
          <p className="form-field-title">{translate.formatMessage({ id: 'carbon.form.landTenure' })}</p>
          <div className="contact-info__wrapper-uploader">
            <DropeZoneContactInfo
              classCustom=""
              type="general"
              change={() => {}}
              multipleFiles
              amountFiles={5}
              droppedFiles={filesListTenure}
              setError={setError}
              notMoreUpload={isMoreThanFive}
              setDroppedFiles={setFilesListTenure}
              previewCustomClass="uploader__doc-dropzone"
            />
          </div>
        </div>
        <div className="contact-info__last-block">
          <p className="form-field-title">{translate.formatMessage({ id: 'carbon.form.otherDoc' })}</p>
          <DropeZoneContactInfo
            classCustom=""
            type="other"
            change={() => {}}
            multipleFiles
            amountFiles={5}
            droppedFiles={filesListOthers}
            setError={setError}
            notMoreUpload={isMoreThanFive}
            setDroppedFiles={setFilesListOthers}
            previewCustomClass="uploader__doc-dropzone"
          />
        </div>
        {children}

        {error && <p className="uploader__error">{error}</p>}
      </div>

    </div>
  );
};

export default UploaderSection;
